/* istanbul ignore file */
export { BreadcrumbComponentsModule } from './breadcrumb.module';
export { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
